import AccountSummaryWidget from "../..";
/**
 * @function AccountSummaryAssetsAndLoansWidget
 * @return {React.Component}
 * @exported true
 * @description An account summary widget that shows assets and loans in separate sections.
 * It is currently a wrapper of component "AccountSummaryWidget".
 */
export default function AccountSummaryAssetsAndLoansWidget(props) {
  return(
    <AccountSummaryWidget key="accountSummary_1" className="show-on-mobile assets-and-loans" view="mobile" showAssetsAndLoansUI="true" />
  );
}
